import createRequestBuilder from "./request"

export async function addAffinitySignals(signals: Record<string, string[]>): Promise<void> {
  await createRequestBuilder().setAffinitySignals(signals).load({ skipPageViews: true })
}
